import {DetailsFormData} from "./models";
import {AddressFormData} from "./models";
import {Dictionary} from "./utils";
import {ContactFormData} from "./models";

declare var validate;

// For validation we are using the validate.js library (https://validatejs.org) which is loaded from within the html page

var detailsFormConstraints = {
    name: {
        presence: true
    },
    surname: {
        presence: true
    },
    email: {
        presence: true,
        email: true
    },
    areaCode: {
        numericality: {
            onlyInteger: true
        }
    },
    contactNumber: {
        presence: true,
        numericality: true,
        length: {
            minimum: 6
        }
    }
};

var addressFormConstraints = {
    streetNumber: {
        presence: true
    },
    streetName: {
        presence: true
    },
    city: {
        presence: true
    },
    zipCode: {
        presence: true
    },
    country: {
        presence: true
    }
};

var contactFormConstraints = {
    name: {
        presence: true
    },
    email: {
        presence: true,
        email: true
    },
    subject: {
        presence: true
    },
    message: {
        presence: true
    }
};

export function validateDetailsFormData(data: DetailsFormData) : Dictionary<string[]> {
    var errors = validate(data, detailsFormConstraints);

    // We are combining the areaCode and contactNumber errors into one field "phone" so that we can display the error
    // messages for both fields at once

    if (errors && (errors['areaCode'] || errors['contactNumber'])) {
        errors['phone'] = (errors['areaCode'] || []).concat( errors['contactNumber'] || [] );
    }

    return errors || {};
}

export function validateAddressFormData(data: AddressFormData) : Dictionary<string[]> {
    var errors = validate(data, addressFormConstraints);

    // We are combining the streetNumber and streetName errors into one field "address" so that we can display the error
    // messages for both fields at once

    if (errors && (errors['streetNumber'] || errors['streetName'])) {
        errors['address'] = (errors['streetNumber'] || []).concat( errors['streetName'] || [] );
    }

    return errors || {};
}

export  function validateContactFormData(data: ContactFormData) : Dictionary<string[]> {
    return validate(data, contactFormConstraints);
}
